module.exports = __webpack_public_path__ + "static/media/ask-atmosphere.4c47ddc5.jpg";